import { setSearchResults } from "../../redux/features/topicsSlice";
import { useSearchToggle } from "../../contexts/SearchContext";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export const Search = ({ type, placeholder, setFormVisible, setNewPost }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // =======================
  // Custom hooks
  // =======================
  const toggleSearchModal = useSearchToggle();

  // =======================
  // Redux State Managament
  // =======================

  const { searchResults } = useSelector((state) => state.topics);
  const { searchQuery: oldSearchQuery, searchResult } = searchResults;
  const handleInputFocus = () => {
    setDropdownVisible(true);
  };

  // =======================
  // User Authentication
  // =======================
  const userObj = localStorage.getItem("salla_discourse_user");
  const user = JSON.parse(userObj);
  let isLoggedin = false;
  if (user) {
    isLoggedin = true;
  }

  // =======================
  // useStates
  // =======================
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  // =======================
  // useRefs
  // =======================
  const searchRef = useRef(null);
  const dropdownRef = useRef(null);

  // =======================
  // useEffect
  // =======================
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        searchRef.current &&
        !searchRef.current.contains(event.target)
      ) {
        setDropdownVisible(false);
        if (type === "global") {
          toggleSearchModal();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggleSearchModal, type]);

  // =======================
  // Handlers
  // =======================
  const handleSearch = async () => {
    try {
      if (oldSearchQuery && oldSearchQuery === searchRef.current?.value) {
        return;
      }
      const encodedQuery = encodeURIComponent(searchRef.current?.value);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/search.json?q=${encodedQuery}`
      );

      const data = response.data;
      const { topics } = data;

      const closed_topics = topics?.filter((topic) => topic.closed === false);

      dispatch(
        setSearchResults({
          searchQuery: searchRef.current?.value,
          searchResult: closed_topics,
        })
      );
    } catch (err) {
      console.error(err);
    }
  };

  const createNewTopic = () => {
    if (type === "global") {
      toggleSearchModal();
    }
    setDropdownVisible(false);
    setFormVisible(true);
    setNewPost((prev) => ({
      ...prev,
      title: searchRef.current?.value,
    }));
  };

  return (
    <div
      className={`relative w-full h-fit max-w-[600px] mx-auto ${
        type === "global" ? "top-[13rem] sm:right-[6rem]" : ""
      }`}
      ref={dropdownRef}
    >
      <div className="relative w-full flex justify-center sm:block">
        <form
          className="relative sm:w-full"
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
            handleInputFocus();
          }}
        >
          <input
            ref={searchRef}
            type="search"
            id="search-bar"
            className="transition-all searchInput shadow-lg rounded-full h-[54px] w-[94vw] sm:w-full px-4 pr-[50px] pl-4 text-right placeholder:text-[#707070] focus:outline-0 focus:border-[#666666] border border-white"
            placeholder={placeholder}
            style={{
              backgroundImage: "url('/images/sidebar/search.svg')",
              backgroundSize: "20px 20px",
              backgroundRepeat: "no-repeat",
              backgroundPosition:
                window.innerWidth <= 480 ? "73% center" : "67% center",
            }}
            /* animate the spyglass */
            onFocus={(e) => {
              e.target.style.backgroundPosition = "calc(100% - 16px) center";
              e.target.placeholder = "";
            }}
            onBlur={(e) => {
              if (!e.target.value) {
                e.target.style.backgroundPosition =
                  window.innerWidth <= 480 ? "73% center" : "67% center";
                e.target.placeholder = placeholder;
              }
            }}
            /* keep the spyglass at the start if the input has data */
            onChange={(e) => {
              e.preventDefault();
              if (e.target.value.length > 2) {
                handleSearch();
              }
              handleInputFocus();
              if (e.target.value) {
                e.target.style.backgroundPosition = "calc(100% - 16px) center";
              } else {
                setDropdownVisible(false);
              }
            }}
          />
        </form>
      </div>
      {isDropdownVisible && (
        <div
          className="absolute top-[65px] sm:left-0 left-[-16px] sm:right-0 right-[-16px] mt-[-6px] bg-white rounded-[8px] shadow-lg z-10 overflow-hidden"
          style={{ overflowY: "auto" }}
        >
          {type === "local" && (
            <div
              className="cursor-pointer justify-center px-3 py-4 border-[1px] hover:bg-secondary-25 transition-colors border-[#76E8CD] mx-4 my-3 rounded-lg flex"
              onClick={() => {
                if (!isLoggedin) {
                  // navigate('/login');
                  window.location.href =
                    process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
                } else {
                  createNewTopic();
                }
              }}
            >
              <button className="text-sm cursor-pointer text-[#004D5A] font-bold flex gap-2">
                <img src="/images/home/pencil.svg" alt="create topic" />
                <p className="w-[8rem]">اكتب موضوع جديد</p>
              </button>
            </div>
          )}
          <p className="text-[#999999] text-[14px] m-5">
            {searchResult?.length
              ? searchResult.length + "مواضيع"
              : "لا توجد نتائج"}
          </p>
          <ul className="mr-4 text-right">
            {searchResult?.map((result, index) => (
              <li
                key={index}
                className="mb-2 font-medium hover:underline cursor-pointer last:mb-0 text-[#444444] text-[14px] cursor-pointerpx-2 py-2 rounded flex gap-3"
                onClick={() => {
                  if (type === "global") {
                    toggleSearchModal();
                  }
                  navigate(
                    `/detail/${result.id}/${result.highest_post_number}`
                  );
                }}
              >
                <img src="/images/home/bubble-chat.svg" alt="" />
                {result.title}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
